import React from "react";
import InductionSearch from "./InductionSearch";

function GraduationSearch() {
  return <InductionSearch isGraduation />;
}

export default GraduationSearch;
